import * as ActionTypes from '../action-types'

const group_defaultState = {
    byID: {},
    byCoid: {},
    allIDs: [],
}

export const group = (state = group_defaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GROUP_GET_ALL: {

            const groups = action.group

            groups
            &&
            groups.length
            &&
            groups.map(group => {

                const { groupid } = group

                newState.byID[groupid] = group

                if(!newState.allIDs.includes(groupid)) newState.allIDs.push(groupid)

                return null
            })

            return newState;
        }
        case ActionTypes.CREATE_GROUP: {

            const groups = action.group

            const { groupid } = groups

            newState.byID[groupid] = groups

            if(!newState.allIDs.includes(groupid)) newState.allIDs.push(groupid)

            return newState;
        }
        case ActionTypes.UPDATE_GROUP: {
            const group = action.group;
            const { groupid } = group;
          
            newState.byID[groupid] = group;
          
            if (!newState.allIDs.includes(groupid)) {
              newState.allIDs.push(groupid);
            }
          
            return newState;
          }
        case ActionTypes.GET_GROUP_BY_COID: {
          const group = action.group;
    
          newState.byCoid = group;
    
          return newState;
        }
        default: {
            return state;
        }
    }
}
